import React, { useEffect, useState } from 'react';
import style from './index.module.scss';
import { sendPoint, getWithAuth } from '@/util';
import { useMobile } from '@/hooks/common';
import LogDiv from '@/commonComponents/logDiv';
import { useToast } from '@/stores/ToastContext';
import { useRouter } from 'next/router';
import H5Image from 'web-materials/dist/esm/components/common/H5Image';

const Overtime = 60;

export default () => {
  const router = useRouter();

  const [platform, setPlatform] = useState<any>(undefined);
  const [requestId, setRequestId] = useState<any>(undefined);
  const [status, setStatus] = useState<any>(undefined);
  const [isMobile] = useMobile();
  const [count, setCount] = useState<number>(0); // Timer will execute 60 times maximum
  const startTime = Date.now();
  const [orderStatus, setOrderStatus] = useState<string>(undefined);
  const showToast = useToast();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const platform = params.get('platform');
    platform && setPlatform(platform);
    const status = params.get('status');
    status && setStatus(status);
    const requestId = params.get('third_order_id');
    requestId && setRequestId(requestId);
    const orderStatus = params.get('s');
    orderStatus && setOrderStatus(orderStatus);
    if (orderStatus === 'failed') {
      setCount(5);
    } else {
      setCount(Overtime);
    }
  }, []);

  // Track page leave with duration
  useEffect(() => {
    const handleBeforeUnload = () => {
      const duration = Math.floor((Date.now() - startTime) / 1000);
      sendPoint({
        event_name: 'duet_phone_website_purchase_process_page_leave',
        duration,
      });
    };

    return handleBeforeUnload;
  }, []);

  // Track overtime (over one minute)
  useEffect(() => {
    const overtimeTimer = setTimeout(() => {
      sendPoint({
        event_name: 'duet_phone_website_purchase_process_page_overtime',
      });
    }, Overtime * 1000);

    return () => {
      clearTimeout(overtimeTimer);
    };
  }, []);

  useEffect(() => {
    let timer = null;
    if (status === 'FAILED') {
      router.push('/pay_error');
    } else {
      timer = setInterval(() => {
        setCount((prevCount) => {
          const newCount = prevCount - 1;
          // Clear timer after 60 executions (when count reaches 0)
          if (newCount <= 0 && timer) {
            clearInterval(timer);
          }
          return newCount;
        });
        if (requestId !== undefined) {
          const orderId = requestId;
          getWithAuth(`/web/payment/users/me/thirdparty/orders/${orderId}?platform=${platform}`)
            .then(async (res) => {
              const flag = res?.data?.thirdPartyOrders?.[0]?.status;
              const canRetry = res?.data?.thirdPartyOrders?.[0]?.canRetry;
              if (orderStatus === 'failed' && canRetry) {
                router.push(`/pay_error?can_retry=true&platform=${platform}&id=${orderId}`);
              } else if (flag === 'success') {
                await sendPoint({
                  event_name: `duet_${isMobile ? 'phone' : 'web'}_website_pay_pending_page_purchase.success`,
                  orderId,
                });
                if (isMobile) {
                  window.location.href = 'https://duet.onelink.me/GBnZ/t3682sma';
                } else {
                  router.replace('/playground_mobile');
                  showToast('your purchase is successful, you can go to the app to enjoy your time');
                }
              } else if (flag === 'failed' || flag === 'closed' || flag === 'skipped') {
                router.push('pay_error');
              } else if (res.meta.code === 401000) {
                router.push('/login');
                // 不做处理
              }
            })
            .catch((e) => {
              console.log(e);
            });
        }
      }, 1000);
    }

    return () => {
      if (timer !== null) {
        clearInterval(timer);
      }
      if (count <= 0 && orderStatus === 'failed') {
        router.push('/pay_error');
      }
    };
  }, [requestId, status, count]);

  return (
    <LogDiv className={style.wrapper} impr="duet_phone_website_purchase_process_page">
      <div className={style.content}>
        <H5Image
          type="origin"
          src="https://cdn.duetapp.net/v1/images/eyJpZCI6IlczRFE1RlZKVldTVUVFQVRPQ0ZMVEdRUEZPR0dOVyIsInciOjk2LCJoIjo5NiwiZCI6MCwibXQiOiJpbWFnZS9qcGVnIiwiZGgiOjUxODE5NjI3NzQzMTg0MTA3MX0"
        />
        <div className={style.tip}>
          Your purchase is being processed. It may take several minutes. We&apos;ll inform you when it&apos;s complete.
        </div>
      </div>
    </LogDiv>
  );
};
